export default "__VITE_ASSET__B8Iu3YvA__"